import { PublicClientApplication } from '@azure/msal-browser';

let msalInstance;

const port = window.location.port ? `:${window.location.port}` : '';
const redirectUri = `${window.location.protocol}//${window.location.hostname}${port}/authsuccess`;

export const createMSALInstance = () => {
  if (!(msalInstance instanceof PublicClientApplication)) {
    msalInstance = new PublicClientApplication({
      auth: {
        clientId:
          window.TIEOUT.ENV.GEOS[window.TIEOUT.ENV.CURRENT_GEO].AD_CLIENT,
        authority: `${window.TIEOUT.ENV.AD_INSTANCE}${window.TIEOUT.ENV.AD_TENANT}`,
        redirectUri: redirectUri,
        knownAuthorities: [
          `${window.TIEOUT.ENV.AD_INSTANCE}${window.TIEOUT.ENV.AD_TENANT}`,
        ],
        postLogoutRedirectUri: 'https://www.deloitte.com/',
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
      },
    });
    return msalInstance;
  }
};

export const getMSALInstance = () => {
  if (!msalInstance) {
    throw new Error(
      'MSAL instance not created. Call createMSALInstance first.',
    );
  }
  return msalInstance;
};
